import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  Input,
  SimpleChanges,
} from "@angular/core";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { FilterByTagsComponent } from "../filterByTags/filterbytags.component";
import { Subject, Subscription } from "rxjs";
import * as Models from "./service-charges.model";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { ServiceService } from "./chargeser.service";
import { take } from "rxjs/operators";
import { debounceTime } from "rxjs/operators";
import { MonthlyExpandService } from "../monthlybilling.service";
import { MonthlyComponent } from "./chargesbyservice_type/monthly/monthly.component.";
import { WeeklyComponent } from "./chargesbyservice_type/weekly/weekly.component";
import { DailyComponent } from "./chargesbyservice_type/daily/daily.component";

declare var bootstrap: any;
@Component({
  selector: "app-charges-by-service",
  templateUrl: "./chargesbyservice.component.html",
  styleUrls: ["./chargesbyservice.component.css"],
})
export class ChargesByServiceComponent implements OnInit, OnDestroy {
  @ViewChild(FilterByTagsComponent) filterComponent!: FilterByTagsComponent;
  @ViewChild(MonthlyComponent) monthlyComp!: MonthlyComponent;
  @ViewChild(WeeklyComponent) weeklyComp!: WeeklyComponent;
  @ViewChild(DailyComponent) dailyComp!: DailyComponent;
  @Input() monthYear: any;
  @Input() accountId: any;
  @Input() regionId: any;
  accountOptions: { id: number; name: string }[] = [];

  selectedAccountIds: any = [];

  breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };

  gear: boolean = false;
  currentPage = 1;
  pageSizeOptions = [20, 50, 100];

  filterTags = false;

  headers: Models.Header[] = [
    { key: "product_code", label: "Service Name", sortable: true },
    { key: "usage", label: "Usage", sortable: false },
    { key: "base_cost", label: "Public Cost (USD)", sortable: true },
    { key: "final_cost", label: "Final Cost (USD)", sortable: true },
  ];
  prevMonth: any = [];
  services: Models.Service[] = [];
  sortKey: Models.SortableColumn = "product_code";
  searchTerm = "";
  filter = "";
  sortDirection: "asc" | "desc" = "asc";
  isExpandedAll = false;
  total: any;
  totactiveser: any = 0;
  filteredList: Models.Service[] = [];
  funRef: any = {};
  currentMessage!: Subscription;
  filteredTag: { accountId: string; tagKey: string; tagValue: string } | null =
    null;
  selectedPageSize = 20;
  usagePagination = false;
  preferencesData: {
    pageSize: number;
    wrapLines: boolean;
    usagePagination: boolean;
    visibleColumns: {
      description: boolean;
      usageQuantity: boolean;
      amountUsd: boolean;
    };
    breakpoints: {
      region: boolean;
      product_family: boolean;
      line_item: boolean;
    };
    selectedAccountIds: string[];
  } = {
    pageSize: 20,
    wrapLines: false,
    usagePagination: true,
    visibleColumns: {
      description: true,
      usageQuantity: true,
      amountUsd: true,
    },
    breakpoints: {
      region: false,
      product_family: false,
      line_item: false,
    },
    selectedAccountIds: [],
  };
  chartInstance: any;
  selectedView: any ='monthly';

  constructor(
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService,
    private monthexp: MonthlyExpandService,
  ) {}

  ngOnInit(): void {
    this.preferencesData.selectedAccountIds.push(this.accountId);
    this.funRef = {};

    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras?.state) {
      this.route.queryParams.pipe(take(1)).subscribe((p): void => {
        const { open, _t, ...fp } = p;
        const b =
          p["breakup"]
            ?.toString()
            .split(",")
            .map((x: any) => x.trim())
            .filter(Boolean) || [];
        const allKeys: (keyof typeof this.preferencesData.breakpoints)[] = [
          "region",
          "product_family",
          "line_item",
        ];

        if (p["tag_key"] && p["tag_value"] && b.length) {
          // set breakpoints
          this.preferencesData.breakpoints = {
            ...this.preferencesData.breakpoints,
            ...b.reduce((acc: any, k: string) => ((acc[k] = true), acc), {}),
          };
          this.filteredTag = {
            accountId: p["account_ids"] || this.accountId,
            tagKey: p["tag_key"],
            tagValue: p["tag_value"],
          };
          // this.loadPreferences(fp);
          return;
        }

        if ("mode" in p) {
          allKeys.forEach(
            (k) => (this.preferencesData.breakpoints[k] = b.includes(k))
          );
          // this.loadPreferences(fp);
          return;
        }

        if (!("open" in p)) {
          // this.load();
                console.log('chcek child is being called or not');

          return;
        }

        setTimeout(
          () => 
            // this.loadPreferences({ ...fp, account_ids: this.accountId }),
          100
        );
      });
    } else {
      // this.load();
            console.log('chcek child is being called or not');

    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();
    this.preferencesData = this.getDefaultPreferences();

    if (changedLater("monthYear") || changedLater("accountId")) {
      this.filteredTag = null;
      // this.load();
    }
  }

  handlePageSizeChange(newPageSize: number): void {
    this.selectedPageSize = newPageSize;
const viewMap: Record<string, { handlePageSizeChange: (size: number) => void }> = {
  monthly: this.monthlyComp,
  weekly: this.weeklyComp,
  daily: this.dailyComp
};

viewMap[this.selectedView]?.handlePageSizeChange(this.selectedPageSize);
  }

  private baseParams(accountIds: string | string[]): Record<string, any> {
    const [month, year] = this.monthYear.split("-");
    return { account_ids: accountIds, year, month };
  }

  handlePreferencesResponse(data: any) {
    if(this.selectedView == 'monthly'){
          this.monthlyComp.handlePreferencesResponse(data);
    }
    else if(this.selectedView == 'weekly'){
          this.weeklyComp.handlePreferencesResponse(data);
    }
    else if(this.selectedView == 'daily'){
      this.dailyComp.handlePreferencesResponse(data);
    }
  }

  onTagsFiltered(event: any) {
 this.filteredTag = event;
}

  get totalPages(): number {
    return Math.ceil(this.filteredList.length / this.selectedPageSize);
  }

  get paginatedList(): Models.Service[] {
    const start = (this.currentPage - 1) * this.selectedPageSize;
    const end = start + this.selectedPageSize;
    return this.filteredList.slice(start, end);
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  clearTagFilter() {
    this.filteredTag = null;
   this.monthlyComp.clearTagFilter();
  }

  toggle(item: any) {
    item.expanded = !item.expanded;
  }

updateChartData(event: {
  services: any[],
  prevMonth?: any[],
  total: number,
  totser: number
}) {
  this.total = event.total;
  this.totactiveser = event.totser;
    if (this.selectedView !== 'monthly') {
    this.services = event.services;
  }
  else if (this.selectedView === 'daily') {
    this.services = event.services;
  } 
  else {
    this.services = event.services;
  this.prevMonth = event.prevMonth;
  }
}

  async toggleExpandAll() {
    this.isExpandedAll = !this.isExpandedAll;
  }

  searchSubject: Subject<string> = new Subject<string>();
  searchSubscription!: Subscription;

  onSearch() {
    this.searchSubject.next(this.searchTerm);
  }

  applyFilter(searchText: string) {
    const filterText = searchText.trim().toLowerCase();

    if (!filterText) {
      this.filteredList = [...this.services];
      return;
    }

    this.filteredList = this.services.filter((service) =>
      (service.product_code || "").toLowerCase().includes(filterText)
    );
  }

  trackByProductCode(index: number, item: Models.Service): string {
    return item.product_code;
  }

  private getDefaultPreferences(accountIds: any[] = []): any {
    return {
      pageSize: 20,
      wrapLines: false,
      usagePagination: true,
      visibleColumns: {
        description: true,
        usageQuantity: true,
        amountUsd: true,
      },
      breakpoints: {
        region: false,
        product_family: false,
        line_item: false,
      },
      selectedAccountIds: accountIds,
    };
  }

onViewChange() {
  this.selectedPageSize = 20;
}


ngOnDestroy() {
  this.currentMessage?.unsubscribe();
  this.searchSubscription?.unsubscribe();
}

}
